import { TipTap } from "../types";

const extractImages = (document: any): TipTap.ContentImage[] => {
  const images: any = [];

  function traverse(node: any) {
    if (!node || typeof node !== "object") return;

    if (node.type === "image") {
      images.push(node);
    }

    if (Array.isArray(node.content)) {
      node.content.forEach((child: any) => traverse(child));
    }
  }

  traverse(document);

  return images;
};

export default extractImages;
